(() => {
  "use strict";
  const page = document.querySelector("[data-product-page]");
  if (!page) return;
  const data = JSON.parse(page.querySelector("[data-product-variants]").textContent);
  const form = page.querySelector("[data-product-detail-form]");
  const select = form.querySelector("[data-variant-select]");
  const fields = [...form.querySelectorAll("[data-option-position]")];
  const submit = form.querySelector('[type="submit"]');
  const quantity = form.querySelector('[name="quantity"]');
  const message = form.querySelector("[data-variant-message]");
  let current = data.variants.find(v => v.id === data.initialId);

  const gallery = page.querySelector("[data-gallery]");
  const track = gallery.querySelector("[data-gallery-track]");
  const slides = [...track.querySelectorAll("[data-image-id]")];
  const imageControls = [...gallery.querySelectorAll("[data-gallery-index]")];
  let imageIndex = Math.max(0, slides.findIndex(s => Number(s.dataset.imageId) === data.initialImageId));
  const updateGallery = () => {
    imageIndex = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / (track.clientWidth || 1))));
    imageControls.forEach(b => b.setAttribute("aria-pressed", Number(b.dataset.galleryIndex) === imageIndex));
    const previous = gallery.querySelector("[data-gallery-prev]");
    const next = gallery.querySelector("[data-gallery-next]");
    if (previous) previous.disabled = imageIndex === 0;
    if (next) next.disabled = imageIndex >= slides.length - 1;
  };
  const goToImage = (index, smooth = true) => {
    if (!slides.length) return;
    imageIndex = Math.max(0, Math.min(slides.length - 1, index));
    track.scrollTo({left: imageIndex * track.clientWidth, behavior: smooth && !matchMedia("(prefers-reduced-motion: reduce)").matches ? "smooth" : "instant"});
    if (!smooth) updateGallery();
  };
  imageControls.forEach(b => b.addEventListener("click", () => goToImage(Number(b.dataset.galleryIndex))));
  gallery.querySelector("[data-gallery-prev]")?.addEventListener("click", () => goToImage(imageIndex - 1));
  gallery.querySelector("[data-gallery-next]")?.addEventListener("click", () => goToImage(imageIndex + 1));
  track.addEventListener("scroll", updateGallery, {passive: true});
  track.addEventListener("keydown", event => {
    if (event.key === "ArrowRight" || event.key === "ArrowLeft") {
      event.preventDefault();
      goToImage(imageIndex + (event.key === "ArrowRight" ? 1 : -1));
    }
  });
  new ResizeObserver(() => goToImage(imageIndex, false)).observe(track);
  goToImage(imageIndex, false);

  const zoom = page.querySelector("[data-zoom-dialog]");
  const zoomImage = zoom.querySelector("[data-zoom-target]");
  page.querySelectorAll("[data-zoom-image]").forEach(button => button.addEventListener("click", () => {
    zoomImage.src = button.dataset.zoomImage;
    zoom.showModal();
    document.body.classList.add("product-zoom-open");
  }));
  zoom.querySelector("[data-close-zoom]").addEventListener("click", () => zoom.close());
  zoom.addEventListener("click", event => { if (event.target === zoom) zoom.close(); });
  zoom.addEventListener("close", () => document.body.classList.remove("product-zoom-open"));

  const choices = () => fields.map(f => f.querySelector("input:checked")?.value);
  const syncPrice = variant => {
    if (!variant) return;
    page.querySelector("[data-product-price]").textContent = variant.priceLabel;
    const sale = variant.compare > variant.price;
    const compare = page.querySelector("[data-product-compare]");
    compare.hidden = !sale;
    compare.textContent = sale ? variant.compareLabel : "";
    compare.closest(".price").classList.toggle("price--sale", sale);
    page.querySelector("[data-product-discount]").hidden = !sale;
    page.querySelector("[data-discount-label]").textContent = sale ? `${Math.round((variant.compare - variant.price) * 100 / variant.compare)}% de descuento` : "";
    const sku = page.querySelector("[data-product-sku]");
    if (sku) { sku.textContent = variant.sku || ""; sku.parentElement.hidden = !variant.sku; }
    quantity.min = variant.min;
    quantity.step = variant.step;
    if (variant.max) quantity.max = variant.max;
    else quantity.removeAttribute("max");
    const entered = Number(quantity.value) || variant.min;
    const aligned = variant.min + Math.max(0, Math.round((entered - variant.min) / variant.step)) * variant.step;
    quantity.value = variant.max ? Math.min(variant.max, aligned) : aligned;
    syncQuantityButtons();
  };
  const syncQuantityButtons = () => {
    form.querySelector('[data-quantity-step="-1"]').disabled = Number(quantity.value) <= Number(quantity.min);
    form.querySelector('[data-quantity-step="1"]').disabled = !!quantity.max && Number(quantity.value) >= Number(quantity.max);
  };
  const updateOptions = (updateUrl = false) => {
    // Earlier options constrain later options, so changing a color never traps the shopper in an unavailable size.
    fields.forEach((field, position) => {
      const prefix = choices().slice(0, position);
      field.querySelectorAll('input[type="radio"]').forEach(input => {
        const available = data.variants.some(v => v.available && v.options[position] === input.value && prefix.every((value, i) => !value || v.options[i] === value));
        input.disabled = !available;
        input.closest("label").classList.toggle("option-unavailable", !available);
        input.setAttribute("aria-label", `${input.value}${available ? "" : " · Agotado"}`);
      });
      const selected = field.querySelector("input:checked");
      field.querySelector("[data-selected-option]").textContent = selected ? `· ${selected.value}` : "";
    });
    const selected = choices();
    const complete = data.hasDefaultVariant || selected.every(Boolean);
    current = data.hasDefaultVariant ? data.variants[0] : complete ? data.variants.find(v => v.options.every((value, i) => value === selected[i])) : null;
    select.value = current ? String(current.id) : "";
    const noStock = !data.variants.some(v => v.available);
    submit.disabled = noStock || (complete && !current?.available);
    submit.textContent = submit.disabled ? "Agotado" : "Agregar al carrito";
    message.hidden = !submit.disabled;
    message.textContent = noStock ? "Este producto está agotado." : "Esta combinación no está disponible.";
    syncPrice(current);
    if (updateUrl) {
      const url = new URL(location.href);
      if (current) url.searchParams.set("variant", current.id);
      else url.searchParams.delete("variant");
      history.replaceState({}, "", url);
      if (current?.imageId) {
        const index = slides.findIndex(s => Number(s.dataset.imageId) === current.imageId);
        if (index >= 0) goToImage(index);
      }
    }
  };
  fields.forEach((field, position) => field.addEventListener("change", () => {
    // Clear an incompatible downstream selection instead of silently choosing another size.
    fields.slice(position + 1).forEach(later => {
      const selected = later.querySelector("input:checked");
      if (!selected) return;
      const laterPosition = Number(later.dataset.optionPosition);
      const values = choices();
      const available = data.variants.some(v => v.available && values.slice(0, laterPosition + 1).every((value, i) => !value || v.options[i] === value));
      if (!available) selected.checked = false;
    });
    updateOptions(true);
  }));
  select.addEventListener("change", () => {
    const variant = data.variants.find(v => String(v.id) === select.value);
    if (variant) fields.forEach((field, i) => field.querySelectorAll("input").forEach(input => { input.checked = input.value === variant.options[i]; }));
    updateOptions(true);
  });
  form.querySelectorAll("[data-quantity-step]").forEach(button => button.addEventListener("click", () => {
    if (Number(button.dataset.quantityStep) > 0) quantity.stepUp();
    else quantity.stepDown();
    quantity.dispatchEvent(new Event("change", {bubbles: true}));
  }));
  quantity.addEventListener("change", syncQuantityButtons);
  form.addEventListener("submit", event => {
    if (!current?.available) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const missing = fields.find(field => !field.querySelector("input:checked"));
      message.textContent = missing ? `Selecciona ${missing.querySelector("legend").childNodes[0].textContent.trim().toLowerCase()} antes de agregar al carrito.` : "Esta combinación está agotada.";
      message.hidden = false;
      missing?.querySelector("input:not(:disabled)")?.focus();
    }
  }, true);
  form.addEventListener("product:idle", () => updateOptions());
  form.querySelector(".variant-select-fallback").hidden = true;
  form.querySelector("[data-product-options]")?.removeAttribute("hidden");
  syncPrice(current);
  updateOptions();
})();
